import React from "react";
import { Form, Checkbox } from "semantic-ui-react";
import Swal from "sweetalert2";

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phoneNumber: "",
      subject: "",
      message: "",
      authorize: false,
    };
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleAuthorize = e => {
    this.setState({ authorize: !this.state.authorize });
  };

  handleSubmit = e => {
    const { name, email, phoneNumber, subject, message, authorize } = this.state;

    if (!name || !email || !phoneNumber || !subject || !message) {
      Swal.fire({
        title: "Sorry",
        text: "Please fill in required fields",
        type: "error",
        confirmButtonText: "OK",
      });
    } else if (authorize) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "contact", ...this.state }),
      })
        .then(() => {
          Swal.fire({
            title: "Thanks",
            text: "We will contact you as soon as possible!",
            type: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch(error => alert(error));
    } else {
      Swal.fire({
        title: "Sorry",
        text: "Please click on authorization",
        type: "error",
        confirmButtonText: "OK",
      });
    }
  };

  render() {
    return (
      <Form
        className="contact-form"
        name="contact"
        method="post"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onSubmit={this.handleSubmit}
      >
        <input type="hidden" name="form-name" value="contact" />
        <p hidden>
          <label>
            Don’t fill this out:{" "}
            <input name="bot-field" onChange={this.handleChange} />
          </label>
        </p>
        <Form.Group widths="equal">
          <Form.Input
            fluid
            label={{ children: "Name*", style: { color: '#363131', fontWeight: '500' } }}
            placeholder="Name"
            name="name"
            type="text"
            onChange={this.handleChange}
          />
          <Form.Input
            fluid
            label={{ children: "Email*", style: { color: '#363131', fontWeight: '500' } }}
            placeholder="Email"
            name="email"
            type="email"
            onChange={this.handleChange}
          />
          <Form.Input
            fluid
            label={{ children: "Phone*", style: { color: '#363131', fontWeight: '500' } }}
            placeholder="Phone No."
            name="phoneNumber"
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Input
          fluid
          label={{ children: "Subject*", style: { color: '#363131', fontWeight: '500' } }}
          placeholder="Subject"
          name="subject"
          onChange={this.handleChange}
        />
        <Form.TextArea
          label={{ children: "Message*", style: { color: '#363131', fontWeight: '500' } }}
          placeholder="What would you like to say to us?"
          name="message"
          rows={10}
          onChange={this.handleChange}
        />
        <Form.Group style={{ marginTop: "50px" }}>
          <Form.Field className="custom-checkbox">
            <Checkbox
              label="I authorize the treatment of my personal data by DP Tile and Stone for commercial and promotional finality"
              onChange={this.handleAuthorize}
            />
          </Form.Field>

        </Form.Group>

        <Form.Button
          style={{
            backgroundColor: '#000',
            color: '#fff',
            borderRadius: '0px',
            width: '200px',
            fontWeight: '500',
            padding: '16px'
          }}
          type="submit"
        >
          Submit
        </Form.Button>

      </Form>
    );
  }
}

export default ContactForm;